import { capitalize } from 'lodash';
import {
	Button, ButtonAppearance, ButtonColor, CloseIcon, Dialog, PrivacyIcon,
} from '@aleph/shared-components';
import { TwoFactorStepType } from 'wb-reddit/app/common/components/twoFactor/twoFactorModal';

interface IProps {
	type: TwoFactorStepType
	onClose: () => void
}

export default function TwoFactorHeader({ type, onClose }: IProps) {
	return (
		<Dialog.Header
			preset={{
				prefix: <PrivacyIcon width={24}
					height={24}
				/>,
				title:  `${capitalize(type)} 2-factor authentication`,
				suffix: <Button
					leftNode={
						<CloseIcon />
					}
					appearance={ButtonAppearance.GHOST}
					color={ButtonColor.GRAY}
					onClick={onClose}
				/>,
			}}
		/>
	);
}
